import { render, staticRenderFns } from "./UserEvent.vue?vue&type=template&id=44566e83"
import script from "./UserEvent.vue?vue&type=script&lang=ts"
export * from "./UserEvent.vue?vue&type=script&lang=ts"
import style0 from "./UserEvent.vue?vue&type=style&index=0&id=44566e83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports